import { render, staticRenderFns } from "./NavigationMainItem.vue?vue&type=template&id=0aa95b5a&scoped=true&"
import script from "./NavigationMainItem.vue?vue&type=script&lang=js&"
export * from "./NavigationMainItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMainItem.vue?vue&type=style&index=0&id=0aa95b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa95b5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
